export default __webpack_public_path__ + "media/images/messagecards/flower-8fb169a5341bb10b552caa5297019144.jpg";